module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAK9JREFUKBWNkAERgkAQRW8sIBGMQIRtoA3cCES4JtIAG5DBBNrAM4G+Dw7eiah/5nH7/+3CDiG8ZJQd3OEKPRh8VEuqxgj2pOFMcIBChlNzXaSj2XBoSMOTjlRxcvPCic55rDdYHrzVFV4b6AwrWKv4Vxo4Qf1lwLi7gTYZtOMpU422eCrT/rFIMS3o3+9BTWILatb+DjM5yQXUIBI04LA4xN0gfSGXY34O5QOqHdIDusQkM+60XKgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/loupe.png
// module id = 205
// module chunks = 0